import {Injectable} from "@angular/core";
import {Actions, createEffect, Effect, ofType} from "@ngrx/effects";
import {Store} from "@ngrx/store";
import {IAppState} from "../../state/app.state";
import {EPartnerActions, GetPartnerCreditLimitAmount, GetPartnerCreditLimitAmountFailure, GetPartnerCreditLimitAmountSuccess, GetPartnerDebtAmount, GetPartnerDebtAmountFailure, GetPartnerDebtAmountSuccess, GetPartners, GetPartnersFailure, GetPartnersSuccess} from "../../actions/partners/partners.actions";
import {catchError,  map, switchMap, tap, withLatestFrom} from "rxjs/operators";
import {of} from "rxjs";
import {IPartner, IPartyRelationShipAttributeValue} from "../../models/partners/partners.interface";
import {ApiPlatformService} from "../../../../api/external/api-services/api-platform/api-platform.service";

@Injectable()
export class PartnersEffects {
  Partners$ = createEffect(()=>this._actions$.pipe(
    ofType<GetPartners>(EPartnerActions.GetPartners),
    withLatestFrom(this._store$),
    switchMap(([action,storeState]) =>{
      return this.apiPlatformService.getPartnersOld(storeState.authentication.data.accessToken)
        .pipe(
          map(
            result => {
              console.log('getPartners effect');
              console.log(result);
              const partnersArray:Array<IPartner> = [];
              result['report'].forEach((item) =>{
                const parentStatus = item['ChildRelationshipStatus'];
                const childStatus = item['ParentRelationshipStatus'];
                if (childStatus!=='NONE' || parentStatus!=='NONE') {

                  const partner: IPartner = {
                    partyId: item['ID'],
                    partnerType: item['TypeCode'],
                    name: item['Name'],
                    direction: '',
                    status: item['StatusCode'],
                    parentRelationship: {
                      id: item['IdRlshp'],
                      status: item['ParentRelationshipStatus'],
                      profile: item['ProfileRlshp'],
                      attributes: {
                        debtAmount: this.getEmptyAttribute(),
                        creditLimit: this.getEmptyAttribute()
                      }
                    },
                    childRelationship: {
                      id: item['IdChldRlshp'],
                      status: item['ChildRelationshipStatus'],
                      profile: item['ProfileChldRlshp'],
                      attributes: {
                        debtAmount: this.getEmptyAttribute(),
                        creditLimit: this.getEmptyAttribute()
                      }
                    }

                  };
                  if (childStatus !== 'NONE') {
                    partner.direction = 'PARENT';
                    partner.parentRelationship.status = childStatus;
                  }
                  if (parentStatus !== 'NONE') {
                    partner.direction = 'CHILD';
                    partner.parentRelationship.status = parentStatus;
                  }
                  partnersArray.push(partner);
                }
              });
              return new GetPartnersSuccess(partnersArray);
            }
          ),
          catchError(error => {
            console.log('GetPartners error');
            console.log(error);
            return of(new GetPartnersFailure());
          }
          )
        );
      }
    )
  ));
  PartnersSuccess$ = createEffect(()=>this._actions$.pipe(
    ofType<GetPartnersSuccess>(EPartnerActions.GetPartnersSuccess),
    withLatestFrom(this._store$),
    tap(
      ([action,storeState]) =>{
        action.payload.forEach((partner) =>{
          if (partner.direction === 'CHILD') {
            //this._store$.dispatch( new GetPartnerDebtAmount(partner.partyId));
            //this._store$.dispatch( new GetPartnerCreditLimitAmount(partner.partyId));
          }
        });
        console.log('GetPartnersSuccess effect');
      }
    )
  ),{dispatch: false});
  DebtAmount$ = createEffect(()=>this._actions$.pipe(
    ofType<GetPartnerDebtAmount>(EPartnerActions.GetPartnerDebtAmount),
    withLatestFrom(this._store$),
    switchMap(([action,storeState]) =>{
        return this.apiPlatformService.getPartyRelationshipAttribute(storeState.authentication.data.accessToken,action.payload,storeState.authenticatedUser.data.selectedPartyId,'DEBT_AMOUNT')
          .pipe(
            map(
              result => {
                const partnersArray:Array<IPartner> = storeState.partners.data;
                if (result['report'].length>0) {
                  partnersArray.forEach((partner) => {
                    if (partner.partyId === action.payload) {
                      partner.parentRelationship.attributes.debtAmount.valueString = result['report'][0]['AttributeValueV'];
                      partner.parentRelationship.attributes.debtAmount.valueNumber = result['report'][0]['AttributeValueN'];
                      partner.parentRelationship.attributes.debtAmount.valueDate = result['report'][0]['AttributeValueD'];
                      partner.parentRelationship.attributes.debtAmount.isLoaded = true;
                    }
                  });
                }
                return new GetPartnerDebtAmountSuccess(partnersArray);
              }
            ),
            catchError(error => {
                console.log(error);
                return of(new GetPartnerDebtAmountFailure());
              }
            )
          );
      }
    )
  ));

  CreditLimit = createEffect(()=>this._actions$.pipe(
    ofType<GetPartnerCreditLimitAmount>(EPartnerActions.GetPartnerCreditLimitAmount),
    withLatestFrom(this._store$),
    switchMap(([action,storeState]) =>{
        return this.apiPlatformService.getPartyRelationshipAttribute(storeState.authentication.data.accessToken,action.payload,storeState.authenticatedUser.data.selectedPartyId,'CREDIT_LIMIT')
          .pipe(
            map(
              result => {
                const partnersArray:Array<IPartner> = storeState.partners.data;
                if (result['report'].length>0) {
                  partnersArray.forEach((partner) => {
                    if (partner.partyId === action.payload) {
                      partner.parentRelationship.attributes.creditLimit.valueString = result['report'][0]['AttributeValueV'];
                      partner.parentRelationship.attributes.creditLimit.valueNumber = result['report'][0]['AttributeValueN'];
                      partner.parentRelationship.attributes.creditLimit.valueDate = result['report'][0]['AttributeValueD'];
                      partner.parentRelationship.attributes.creditLimit.isLoaded = true;
                    }
                  });
                }
                return new GetPartnerCreditLimitAmountSuccess(partnersArray);
              }
            ),
            catchError(error => {
                console.log(error);
                return of(new GetPartnerCreditLimitAmountFailure());
              }
            )
          );
      }
    )
  ));


  getEmptyAttribute():IPartyRelationShipAttributeValue {
    return {
      valueString: '',
      valueDate: '',
      valueNumber: 0,
      isLoaded: false
    };
  }
  constructor(
    private apiPlatformService: ApiPlatformService,
    private _actions$: Actions,
    private _store$: Store<IAppState>
  ) {}

}

